import type {Nullish} from 'shared/web';

/**
 * Builds the Chips `onChange` handler shared by every filter's quick-filter
 * chips: a selected chip value is forwarded as the filter value; deselecting
 * restores `defaultValue`.
 */
export function makeOnChipsChange<T>(
  setFilterValue: (value: T) => void,
  defaultValue: T
): (values: string[] | Nullish) => void {
  return (values) => {
    if (values && values.length > 0) {
      setFilterValue(values[0] as T);
    } else {
      setFilterValue(defaultValue);
    }
  };
}
